<div class="p-6">

  <!-- Encabezado -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">Workflows</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Gestión de automatizaciones del CRM</p>
    </div>
    <ng-container *appHasPermission="'workflows:create'">
      <a routerLink="/automation/workflows/crear"
         class="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        Nuevo Workflow
      </a>
    </ng-container>
  </div>

  <!--
    Mensajes. El éxito va SIEMPRE por ToastService (INC_CRM_020 (2) inc11); el banner
    de error se conserva porque debe quedar fijo mientras el usuario corrige.
  -->
  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex items-center justify-between text-sm">
      <span>{{ error }}</span>
      <button (click)="error = ''" class="ml-2 text-red-500 hover:text-red-700">&times;</button>
    </div>
  }

  <!-- Filtros -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4 mb-4">
    <div class="flex flex-wrap gap-3">
      <!-- Búsqueda -->
      <div class="flex-1 min-w-50">
        <div class="relative">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input type="text" placeholder="Buscar workflows..."
                 [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
                 class="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        </div>
      </div>
      <!-- Estado -->
      <select [(ngModel)]="selectedStatus" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        @for (opt of statusOptions; track opt.value) {
          <option [value]="opt.value">{{ opt.label }}</option>
        }
      </select>
      <!-- Tipo de objeto -->
      <select [(ngModel)]="selectedObjectType" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        @for (opt of objectTypeOptions; track opt.value) {
          <option [value]="opt.value" [disabled]="opt.disabled">{{ opt.label }}</option>
        }
      </select>
      <!-- Carpeta -->
      <select [(ngModel)]="selectedFolderId" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option value="">Todas las carpetas</option>
        @for (folder of activeFolders; track folder.id) {
          <option [value]="folder.id">{{ folder.name }}</option>
        }
      </select>
      <!-- Limpiar -->
      @if (searchTerm || selectedStatus || selectedObjectType || selectedFolderId !== '') {
        <button (click)="clearFilters()"
                class="px-3 py-2 text-sm text-gray-500 hover:text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          Limpiar filtros
        </button>
      }
    </div>
  </div>

  <!-- Tabla -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
    @if (loading) {
      <div class="flex items-center justify-center py-16 text-gray-400">
        <svg class="animate-spin w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        Cargando workflows...
      </div>
    } @else if (workflows.length === 0) {
      <div class="flex flex-col items-center justify-center py-16 text-gray-400">
        <svg class="w-12 h-12 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
        </svg>
        <p class="text-lg font-medium text-gray-500 dark:text-gray-400">No hay workflows</p>
        <p class="text-sm text-gray-400 mt-1">Crea tu primer workflow para empezar a automatizar.</p>
        <a routerLink="/automation/workflows/crear"
           class="mt-4 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors">
          Crear Workflow
        </a>
      </div>
    } @else {
      <!--
        INC_CRM_020 (7) inc22 — el scroll horizontal ya no se alterna al abrir el menú "⋯": el
        menú se posiciona con `fixed` y no lo recorta ningún ancestro. Alternarlo perdía el
        `scrollLeft`, así que la columna de acciones se salía de la vista en el mismo clic.
      -->
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Nombre</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Tipo de objeto</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Estado</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Carpeta</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Etiquetas</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Actualizado</th>
              <th class="text-right px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (workflow of workflows; track workflow.id) {
              <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
                <!-- Nombre -->
                <td class="px-4 py-3">
                  <button type="button" (click)="verDetalle(workflow)"
                     class="text-left font-medium text-gray-900 dark:text-white hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    {{ workflow.name }}
                  </button>
                  @if (workflow.description) {
                    <p class="text-xs text-gray-400 mt-0.5 truncate max-w-60">{{ workflow.description }}</p>
                  }
                  @if (workflow.isTemplate) {
                    <span class="inline-flex items-center text-xs text-amber-600 mt-0.5">
                      <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                      </svg>
                      Plantilla
                    </span>
                  }
                </td>
                <!-- Tipo de objeto -->
                <td class="px-4 py-3">
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="getObjectTypeClass(workflow.objectType)">
                    {{ getObjectTypeLabel(workflow.objectType) }}
                  </span>
                </td>
                <!-- Estado -->
                <td class="px-4 py-3">
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="getStatusClass(workflow.status)">
                    {{ getStatusLabel(workflow.status) }}
                  </span>
                </td>
                <!-- Carpeta -->
                <td class="px-4 py-3 text-gray-600 dark:text-gray-400">
                  {{ getFolderName(workflow.idFolder) }}
                </td>
                <!-- Etiquetas -->
                <td class="px-4 py-3">
                  <div class="flex flex-wrap gap-1">
                    @for (tag of formatTags(workflow.tags); track tag) {
                      <span class="inline-flex px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 text-xs rounded">
                        {{ tag }}
                      </span>
                    }
                    @if (hasMoreTags(workflow.tags) > 0) {
                      <span class="inline-flex px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 text-gray-500 text-xs rounded">
                        +{{ hasMoreTags(workflow.tags) }}
                      </span>
                    }
                  </div>
                </td>
                <!-- Actualizado -->
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400 text-xs">
                  {{ workflow.datetimeUpdated | date:'dd/MM/yyyy HH:mm' }}
                </td>
                <!-- Acciones -->
                <td class="px-4 py-3">
                  <div class="flex items-center justify-end gap-1">
                    <!--
                      INC_CRM_020 (2) inc4 — "Ver detalle" abre el MODAL, como en contactos,
                      leads, segmentos, formularios y business. Antes navegaba a una página
                      propia: workflows era el único módulo con detalle de página completa.
                    -->
                    <button type="button" (click)="verDetalle(workflow)"
                       title="Ver detalle"
                       class="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    </button>
                    <!-- Editar -->
                    @if (canEdit(workflow)) {
                      <ng-container *appHasPermission="'workflows:edit'">
                        <a [routerLink]="['/automation/workflows', workflow.id, 'editar']"
                           title="Editar"
                           class="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                          </svg>
                        </a>
                      </ng-container>
                    }
                    <!-- Activar -->
                    @if (canActivate(workflow)) {
                      <button (click)="activate(workflow)" title="Activar"
                              [appDisableWithoutPermission]="'workflows:edit'"
                              class="p-1.5 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-md transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                      </button>
                    }
                    <!-- Pausar -->
                    @if (canPause(workflow)) {
                      <button (click)="pause(workflow)" title="Pausar"
                              [appDisableWithoutPermission]="'workflows:edit'"
                              class="p-1.5 text-gray-400 hover:text-yellow-600 hover:bg-yellow-50 rounded-md transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                      </button>
                    }
                    <!-- Duplicar -->
                    <button (click)="openDuplicateModal(workflow)" title="Duplicar"
                            [appDisableWithoutPermission]="'workflows:create'"
                            class="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                      </svg>
                    </button>
                    <!-- Guardar como plantilla -->
                    <button (click)="openTemplateModal(workflow)" title="Guardar como plantilla"
                            [appDisableWithoutPermission]="'workflows:create'"
                            class="p-1.5 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-md transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
                      </svg>
                    </button>
                    <!-- Archivar -->
                    @if (canArchive(workflow)) {
                      <button (click)="archive(workflow)" title="Archivar"
                              [appDisableWithoutPermission]="'workflows:delete'"
                              class="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                        </svg>
                      </button>
                    }
                    <!-- Restaurar (solo archivados) -->
                    @if (canRestore(workflow)) {
                      <button (click)="restore(workflow)" title="Restaurar"
                              [appDisableWithoutPermission]="'workflows:edit'"
                              class="p-1.5 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-md transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v6h6M3 13a9 9 0 1 0 3-7.7L3 8"/>
                        </svg>
                      </button>
                    }

                    <!--
                      INC_CRM_020 (2) inc1 — Constructor, Inscripciones y Pruebas y activación
                      son configuración/operación del workflow, no información de detalle. QA
                      pidió sacarlos de la vista de detalle; su sitio natural es este menú de la
                      fila.

                      Monitoreo se sacó entonces por "ya tiene su propio módulo", pero ese módulo
                      no está en el menú lateral (es por workflow, no global) y nadie lo enlazaba:
                      la página quedó inalcanzable. Vuelve aquí, y su resumen a la pestaña
                      «Monitoreo» del detalle.
                    -->
                    <div>
                      <button type="button" (click)="toggleRowMenu(workflow.id, $event)"
                              title="Más acciones"
                              class="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors">
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM18 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                        </svg>
                      </button>
                      @if (openRowMenuId === workflow.id) {
                        <!-- `fixed`: escapa del overflow de la tarjeta y del scroll del layout (inc22). -->
                        <div class="fixed w-56 z-dropdown rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg py-1"
                             [style.top.px]="rowMenuTop"
                             [style.left.px]="rowMenuLeft">
                          <a [routerLink]="['/automation/workflows', workflow.id, 'builder']"
                             (click)="openRowMenuId = null"
                             class="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
                            Constructor del flujo
                          </a>
                          <a [routerLink]="['/automation/workflows', workflow.id, 'enrollments']"
                             (click)="openRowMenuId = null"
                             class="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
                            Inscripciones
                          </a>
                          <a [routerLink]="['/automation/workflows', workflow.id, 'testing']"
                             (click)="openRowMenuId = null"
                             class="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
                            Pruebas y activación
                          </a>
                          <a [routerLink]="['/automation/workflows', workflow.id, 'monitoring']"
                             (click)="openRowMenuId = null"
                             class="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
                            Monitoreo
                          </a>

                          <!--
                            INC_CRM_020 (4) inc8 — Eliminar. Se muestra SIEMPRE (QA pedía verla en
                            todas las filas) pero solo se habilita sobre workflows ya inactivados;
                            en un ACTIVE queda deshabilitada con el motivo a la vista, en vez de
                            desaparecer y dejar al usuario buscándola.
                          -->
                          <div class="my-1 border-t border-gray-100 dark:border-gray-700"></div>
                          <button type="button" (click)="abrirEliminar(workflow)"
                                  [disabled]="!canDelete(workflow)"
                                  [appDisableWithoutPermission]="'workflows:delete'"
                                  [title]="canDelete(workflow) ? 'Eliminar definitivamente' : 'Pausa o archiva el workflow antes de eliminarlo'"
                                  class="block w-full text-left px-3 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent">
                            Eliminar
                            @if (!canDelete(workflow)) {
                              <span class="block text-xs text-gray-400">Requiere pausarlo o archivarlo</span>
                            }
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      @if (totalPages > 1) {
        <div class="flex items-center justify-between px-4 py-3 border-t border-gray-100 dark:border-gray-700">
          <p class="text-sm text-gray-500">
            {{ currentPage * pageSize + 1 }}–{{ currentPage * pageSize + workflows.length }}
            de {{ totalElements }} workflows
          </p>
          <div class="flex gap-1">
            <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
                    class="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
              ← Anterior
            </button>
            @for (page of pages; track page) {
              @if (page === 0 || page === totalPages - 1 || (page >= currentPage - 1 && page <= currentPage + 1)) {
                <button (click)="goToPage(page)"
                        [class]="page === currentPage
                          ? 'px-3 py-1.5 text-sm bg-blue-600 text-white rounded-md'
                          : 'px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50'">
                  {{ page + 1 }}
                </button>
              }
            }
            <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages - 1"
                    class="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
              Siguiente →
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>

<!-- Modal: Duplicar -->
@if (showDuplicateModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Duplicar Workflow</h3>
      @if (duplicateError) {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded">{{ duplicateError }}</div>
      }
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        Nombre del nuevo workflow
      </label>
      <input type="text" [(ngModel)]="duplicateName"
             class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"/>
      <div class="flex gap-2 mt-4 justify-end">
        <button (click)="closeDuplicateModal()"
                class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">
          Cancelar
        </button>
        <button (click)="confirmDuplicate()" [disabled]="duplicateLoading || !duplicateName.trim()"
                class="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
          {{ duplicateLoading ? 'Duplicando...' : 'Duplicar' }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Modal: Guardar como plantilla -->
@if (showTemplateModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Guardar como Plantilla</h3>
      @if (templateError) {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded">{{ templateError }}</div>
      }
      <div class="space-y-3">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre *</label>
          <input type="text" [(ngModel)]="templateName"
                 class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"/>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
          <textarea [(ngModel)]="templateDescription" rows="2"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white resize-none"></textarea>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Categoría</label>
          <input type="text" [(ngModel)]="templateCategory" placeholder="Ej: Onboarding, Ventas..."
                 class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"/>
        </div>
      </div>
      <div class="flex gap-2 mt-4 justify-end">
        <button (click)="closeTemplateModal()"
                class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">
          Cancelar
        </button>
        <button (click)="confirmSaveTemplate()" [disabled]="templateLoading || !templateName.trim()"
                class="px-4 py-2 text-sm bg-amber-500 text-white rounded-lg hover:bg-amber-600 disabled:opacity-50 disabled:cursor-not-allowed">
          {{ templateLoading ? 'Guardando...' : 'Guardar plantilla' }}
        </button>
      </div>
    </div>
  </div>
}

<!--
  INC_CRM_020 (4) inc11 — el modal propio de "Archivar" que había aquí desapareció: archivar y
  restaurar confirman por `ConfirmDialogService`, el diálogo único del sistema, para que las dos
  acciones se vean y se comporten igual. Ver `archive()` / `restore()` en el componente.

  INC_CRM_020 (4) inc8 — la eliminación sí conserva un diálogo propio porque pide un dato
  (la contraseña) y el diálogo genérico no tiene campo de tipo password.
-->
@if (showDeleteModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <div class="flex items-start gap-3 mb-4">
        <div class="w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center shrink-0">
          <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
        </div>
        <div class="min-w-0">
          <h3 class="text-base font-semibold text-gray-900 dark:text-white">Eliminar Workflow</h3>
          <p class="text-sm text-gray-500 break-words">"{{ deleteTarget?.name }}"</p>
        </div>
      </div>

      <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Se eliminará de forma permanente, junto con sus versiones, nodos, inscripciones y su
        historial de ejecuciones. Esta acción no se puede deshacer.
      </p>

      @if (deleteError) {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded">{{ deleteError }}</div>
      }

      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        Confirma con la contraseña de tu cuenta *
      </label>
      <div class="relative">
        <input [type]="showDeletePassword ? 'text' : 'password'"
               [(ngModel)]="deletePassword"
               (keyup.enter)="confirmarEliminar()"
               autocomplete="current-password"
               placeholder="Tu contraseña"
               class="w-full px-3 py-2 pr-10 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"/>
        <button type="button" (click)="toggleDeletePassword()"
                [title]="showDeletePassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                class="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600">
          @if (showDeletePassword) {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
            </svg>
          } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
            </svg>
          }
        </button>
      </div>

      <div class="flex gap-2 mt-5 justify-end">
        <button (click)="cancelarEliminar()" [disabled]="deleting"
                class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50">
          Cancelar
        </button>
        <button (click)="confirmarEliminar()" [disabled]="deleting || !deletePassword.trim()"
                class="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed">
          {{ deleting ? 'Eliminando...' : 'Eliminar definitivamente' }}
        </button>
      </div>
    </div>
  </div>
}

<!--
  Detalle estándar del sistema (INC_CRM_020 (2) inc1 + inc4): modal con pestañas
  Información + Línea de tiempo, montado aquí igual que en contactos, leads y business.
-->
<app-workflow-detail-modal
  [isOpen]="showDetailModal"
  [workflow]="selectedWorkflow"
  [folders]="folders"
  [ownerName]="selectedOwnerName"
  (close)="cerrarDetalle()"
  (edit)="editarDesdeDetalle($event)" />
